import React, { Component } from 'react'
import Avatar from '../../images/about-avatar.jpg'
import Link from 'gatsby-link'
class Author extends Component {
  constructor(props) {
    super(props)
  }
 
  render() {
    return (
      <div className="author-wrapper">
        <div className="author-avatar">
          <img src={Avatar} alt="Phanor Coll" />
        </div>
        <div className="author-data">
          <h2>Phanor Coll</h2>
          <p>
            {this.props.children}
          </p>
          <Link to="/about" className="a-animation">Learn more about me..</Link>
        </div>
      </div>
    )
  }
}

export default Author



// WEBPACK FOOTER //
// ./src/components/Author/Author.jsx